import React, { useRef, useState } from 'react';
//import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Avatar, Box, ButtonBase, Hidden, Divider } from '@material-ui/core';
import { Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import { logout } from 'src/actions/accountActions';

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  }
}));

function Account() {
  const classes = useStyles();
  const history = useHistory();
  const ref = useRef(null);
  const { t, i18n } = useTranslation(['translation2121']);
  const dispatch = useDispatch();
  const account = useSelector(state => state.me);
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);
  const actualLanguage = i18n.language;

  const userName = account && account.user ? account.user.name : '';
  const userAvatar =
    account && account.user && account.user.avatar
      ? account.user.avatar.secureUrl
      : '';

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const changeLanguage = code => {
    handleClose();
    // Adjustment of Material-UI performed in App.js
    i18n.changeLanguage(code);
  };
  const handleMyProfile = () => {
    handleClose();
    history.push(`/app/account/profile/view`);
  };
  const handleMyOrganization = () => {
    handleClose();
    history.push(`/app/account/organization/view`);
  };
  const handleLogout = async () => {
    try {
      handleClose();
      await dispatch(logout());
      history.push('/');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <Avatar alt="User" className={classes.avatar} src={userAvatar} />
        <Hidden smDown>
          <Typography variant="h6" color="inherit">
            {`${userName}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        {actualLanguage !== 'en' && (
          <MenuItem onClick={() => changeLanguage('en')}>
            {t('translation2121:Label.LanguageEnglish')}
          </MenuItem>
        )}
        {actualLanguage !== 'de' && (
          <MenuItem onClick={() => changeLanguage('de')}>
            {t('translation2121:Label.LanguageGerman')}
          </MenuItem>
        )}
        <MenuItem onClick={handleMyProfile}>
          {t('translation2121:Action.MyProfile')}
        </MenuItem>
        <MenuItem onClick={handleMyOrganization}>
          {t('translation2121:Action.MyOrganization')}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          {t('translation2121:Action.Logout')}
        </MenuItem>
      </Menu>
    </>
  );
}

export default Account;
